import { cookiesStorage } from '$utils/services/cookiesStorage'

export const isCookiesPreferencesAcepted = () => {
  return cookiesStorage.getCookie('cookiesPreferences')
}



// WEBPACK FOOTER //
// ./src/services/user/cookiesPreferences/isCookiesAcepted.service.ts